module.exports = __webpack_public_path__ + "img/arrow-up-square-fill.32d77e30.svg";